(function (TeamAPI, TeamScheduleAPI, _, BaseForm) {

    "use strict";
    angular.module("harriApp")
        .directive('adpDetailsDirective', ['$filter', "TeamCommunicationService", "TeamScheduleService", "$timeout", "hUser", "TSUsersService", function ($filter, TeamCommunicationService, TeamScheduleService, $timeout, hUser, TSUsersService) {
            return {
                restrict: "E",
                replace: 'true',
                scope: {
                    brandId: '=',
                    member: '=',
                    paysheetPayrollType: '='
                },
                templateUrl: '../modules/team_schedule/employer/ADPDetails/views/adp_details.html',
                link: function ($scope, formElement, attrs) {
                    $scope.user = hUser;
                    TeamScheduleService.getActiveBrand()
                        .then(function (brand) {
                            $scope.brand = brand;
                            $scope.getEmployeeActiveLocations(hUser.getUserContext().brand_id, $scope.member.id);
                            $scope.isClockTimeEnabled = TeamScheduleService.isClockTimeAppEnabled();
                            $scope.isADPPayrollSyncEligable = function () {
                                var adminPayrollTypes = ['ADP', 'BENEFIT_MALL','VALIANT','ADP_POSITION'];

                                return (
                                    adminPayrollTypes.indexOf($scope.brand.payroll_type) > -1 &&
                                    TeamScheduleService.isPaySheetAdmin() &&
                                    $scope.isActiveBrandMemberPrimary &&
                                    hUser.isPayrollSyncEnabled() &&
                                    $scope.member &&
                                    $scope.member.is_sent_to_payroll
                                );
                            }
                        });


                    $scope.getEmployeeActiveLocations = function (groupId, userId) {
                        TeamAPI.getEmployeeActiveLocations(groupId, userId)
                            .then(function (locations) {
                                var primaryLocation;
                                $scope.activeLocations = locations.brands;
                                $scope.originalLocations = angular.copy(locations.brands);
                                primaryLocation = _.findWhere(locations.brands, {is_primary: true});

                                $scope.isActiveBrandMemberPrimary = locations.brands &&
                                    locations.brands.length &&
                                    primaryLocation &&
                                    primaryLocation.id === $scope.brand.id;

                            }, function (err) {
                                console.error(err);
                                if (err.status === 422) {
                                    $scope.noActiveBrands = true;
                                } else {
                                    hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong"));
                                }
                                $scope.$digest();
                            });
                    };
                    $scope.modalScope = {};
                    $scope.isEditing = false;
                    $scope.loading = false;
                    $scope.isMemberEmployee = $scope.member && $scope.member.types &&
                        ($scope.member.types.indexOf("EMPLOYEE") > -1 && $scope.member.types.indexOf("EMPLOYER") < 0);

                    var _tcService = new TeamCommunicationService();


                    $scope.showAuditLog = function () {
                        if ($scope.isADPPayrollSyncEligable()) {
                            $scope.isLoadingHistory = true;
                            _tcService.showAuditLog($scope.brand, $scope.member).then(
                                function (logEntries) {
                                    $scope.isLoadingHistory = false;
                                    $scope.logEnteries = logEntries;
                                    setTimeout(function () {
                                        $scope.$digest();
                                    }, 1)
                                },
                                function (err) {
                                    $scope.isLoadingHistory = false;
                                }
                            )
                        }
                    }

                    $scope.showADPDetails = function () {

                        $scope.loading = true;
                        $scope.isRolesShown = true;

                        var promises = {};
                        var payrollPromise = TeamAPI.getPayrollCodeRates($scope.brandId, $scope.member.id);
                        promises['payroll_codes'] = payrollPromise;

                        $q.all(promises)
                            .then(function (res) {

                                var payroll_codes = res.payroll_codes;

                                if (payroll_codes) {
                                    $scope.payrollData = {payrollCodes: [], payroll_id: payroll_codes.payroll_id, point_of_sale_reference_id: payroll_codes.point_of_sale_reference_id};

                                    payroll_codes.pay_rate_codes = payroll_codes.pay_rate_codes || [];

                                    payroll_codes.pay_rate_codes.forEach(function (rate) {
                                        var symbol = $filter('locationCurrencySymbol')($scope.brand);
                                        rate.name = rate.code + " (" + $filter('currency')(rate.rate, symbol) + ")";
                                    });

                                    $scope.payrollData.payrollCodes = payroll_codes.pay_rate_codes;
                                    $scope.OriginalPayrollData = angular.copy($scope.payrollData);
                                }

                                $scope.loading = false;
                                $scope.$digest();
                            });
                    };

                    $scope.showADPDetails();

                    var showSyncMessages = function (msg, status, timeOut) {
                        $scope.isShowingSyncMsg = true;
                        $scope.syncMsg = msg;
                        $scope.isSyncInProgress = (status == "IN-PROGRESS");
                        $scope.didSyncSucceed = (status == "SUCESSS");
                        $scope.didSyncFailed = (status == "FAIL");
                        setTimeout(function () {
                            $scope.$digest()
                        }, 1)
                        if (timeOut > 0) {
                            setTimeout(function () {
                                $scope.isShowingSyncMsg = false;
                                $scope.$digest()
                            }, timeOut * 1000)
                        }
                    }


                    $scope.syncWithADP = function () {
                        hConfirm({
                            text: "Are you sure you want to sync with ADP? This will override any existing details on ADP side?",
                            confirmButton: "Okay",
                            callback: function (confirmed) {
                                if (confirmed) {
                                    showSyncMessages("Syncing wages and rates with " + $scope.brand.paysheet_payroll_type, "IN-PROGRESS", -1);
                                    TeamAPI.syncWithPayroll($scope.brand.id, $scope.member.id, $scope.brand.paysheet_payroll_type, TeamAPI.PAYROLL_SYNC_TYPE.WAGE_DETAILS).then(
                                        function (result) {

                                            if ($scope.member['out_of_sync_sections'].indexOf(TeamAPI.PAYROLL_SYNC_TYPE.WAGE_DETAILS) != -1) {
                                                $scope.member['out_of_sync_sections'].splice($scope.member['out_of_sync_sections'].indexOf(TeamAPI.PAYROLL_SYNC_TYPE.WAGE_DETAILS), 1)
                                                setTimeout(function () {
                                                    $scope.$digest()
                                                }, 1)
                                            }
                                            TSUsersService.updateUserInfo($scope.member.id, $scope.member)
                                            showSyncMessages("Synced Successfully with " + $scope.brand.paysheet_payroll_type, "SUCESSS", 5);

                                        }, function (err) {
                                            showSyncMessages("Something went wrong while syncing the data...", "FAIL", 5);

                                        }
                                    )
                                }
                            }
                        });
                    }

                    var performSavingProcess = function () {
                        TeamAPI.managePayrollCodeRates($scope.brandId, $scope.member.id, $scope.payrollData.payrollCodes, $scope.payrollData.payroll_id, $scope.payrollData.point_of_sale_reference_id)
                            .then(function (res) {
                                if ($scope.isADPPayrollSyncEligable()) {
                                    if ($scope.member['out_of_sync_sections'].indexOf(TeamAPI.PAYROLL_SYNC_TYPE.WAGE_DETAILS) == -1) {
                                        $scope.member['out_of_sync_sections'].push(TeamAPI.PAYROLL_SYNC_TYPE.WAGE_DETAILS);
                                    }
                                }
                                $scope.isEditing = false;
                                $scope.loading = false;
                                $scope.showADPDetails();

                                $scope.$digest();
                            }, function (error) {
                                console.error(error);
                                $scope.isEditing = false;
                                $scope.loading = false;
                                hAlert($filter("translate")("Error"), $filter("translate")("Something went wrong while editing payroll rates"));
                                $scope.$digest();
                            });
                    }

                    $scope.saveRates = function () {
                        if ($scope.editForm.validator.validate()) {
                            $scope.loading = true;
                            if ($scope.activeLocations && $scope.activeLocations.length > 1 && $scope.isADPPayrollSyncEligable()) {
                                hConfirm({
                                    title: 'Saving Payroll Details',
                                    text: "This will override rates & codes defined for " + $scope.member.first_name + " in other locations.",
                                    callback: function (confirmed) {
                                        if (confirmed) {
                                            performSavingProcess();
                                        } else {
                                            $scope.isEditing = false;
                                            $scope.loading = false;
                                            $scope.showADPDetails();
                                        }
                                    }
                                })
                            } else {
                                performSavingProcess();
                            }
                        }
                    };


                    $scope.editADPRate = function (newRateButton) {

                        $scope.loading = true;

                        var promises = {};
                        promises['payroll_codes'] = TeamAPI.getPayrollCodeRates($scope.brandId, $scope.member.id);

                        $q.all(promises)
                            .then(function (res) {
                                var payroll_codes = res.payroll_codes;

                                if (payroll_codes) {
                                    $scope.payrollData.payrollCodes = [];

                                    payroll_codes.pay_rate_codes = payroll_codes.pay_rate_codes || [];

                                    payroll_codes.pay_rate_codes.forEach(function (rate) {
                                        var symbol = $filter('locationCurrencySymbol')($scope.brand);
                                        rate.name = rate.code + " (" + $filter('currency')(rate.rate, symbol) + ")";
                                    });

                                    $scope.payrollData.payrollCodes = payroll_codes.pay_rate_codes;
                                }

                                $scope.loading = false;

                                if (newRateButton) {
                                    $scope.addRate();
                                }

                                $timeout(function () {
                                    var form = function () {
                                        BaseForm.call(this, "edit-adp-details-form", $scope);
                                    };

                                    $scope.editForm = new form();
                                    $scope.editForm.onViewLoaded();

                                    $scope.editForm.validator.validateCustom = function (field, optionsField, rule, showError) {
                                        switch (rule.name) {
                                            case "has-at-least-one-one-code":
                                                var hasAtLeastOne = false;
                                                for (var payrollCodeIndex in $scope.payrollData.payrollCodes) {
                                                    var payrollCode = $scope.payrollData.payrollCodes[payrollCodeIndex].code;
                                                    if (parseInt(payrollCode) == 1) {
                                                        hasAtLeastOne = true;
                                                        break;
                                                    }
                                                }
                                                return hasAtLeastOne;
                                                break;
                                            case "no-empty":
                                                for (var payrollCodeIndex in $scope.payrollData.payrollCodes) {
                                                    var payrollCode = $scope.payrollData.payrollCodes[payrollCodeIndex].code;
                                                    if (!payrollCode || payrollCode == "") {
                                                        return false;
                                                    }
                                                }

                                                break;
                                            case "no-duplicate":
                                                var codesArray = [];
                                                for (var payrollCodeIndex in $scope.payrollData.payrollCodes) {
                                                    var payrollCode = $scope.payrollData.payrollCodes[payrollCodeIndex].code;
                                                    codesArray.push(payrollCode)
                                                }
                                                for (var payrollCodeIndex = 0; payrollCodeIndex < $scope.payrollData.payrollCodes.length; payrollCodeIndex++) {
                                                    var payrollCode = $scope.payrollData.payrollCodes[payrollCodeIndex].code;
                                                    var codeIndex = codesArray.indexOf(payrollCode);
                                                    if (codeIndex !== -1 && codeIndex !== payrollCodeIndex) {
                                                        return false;
                                                    }
                                                }
                                                break;
                                        }

                                        return true;
                                    };

                                    $scope.$digest();
                                }, 1);

                            }, function (error) {
                                $scope.loading = false;
                                console.error(error);
                            });

                        $scope.isEditing = true;
                    };

                    /**
                     * Cancel changes and revert to original roles and wages data
                     */
                    $scope.revertRates = function () {
                        $scope.payrollData = angular.copy($scope.OriginalPayrollData);
                        $scope.isEditing = false;
                    };

                    $scope.showMemberProfile = function () {
                        _tcService.showMemberProfile($scope.brandId, $scope.member.id);
                    };

                    $scope.addRate = function () {
                        $scope.payrollData.payrollCodes = $scope.payrollData.payrollCodes || [];
                        $scope.payrollData.payrollCodes.push({rate: 0.00, code: ""});
                    };

                    $scope.deleteRates = function ($index) {
                        setTimeout(function () {
                            $(".pasyroll_id").trigger("change")
                        }, 1);
                        $scope.payrollData.payrollCodes.splice($index, 1);
                    };
                }
            };
        }]);
})(TeamAPI, TeamScheduleAPI, _, BaseForm);
